import { FC, PropsWithChildren } from 'react';
import { LinearIndeterminateLoader } from '@highmobility/console-ui-components';

export type AuthModalProps = PropsWithChildren<{
  title: string;
  showLoader?: boolean;
}>;

export const AuthModal: FC<AuthModalProps> = (props) => (
  <div className="relative flex w-login-modal-sm flex-col gap-6 rounded bg-dark-green-900 px-6 py-8 sm:gap-8 sm:p-12">
    {props.showLoader && (
      <div className="absolute -top-2 left-0 w-full">
        <LinearIndeterminateLoader />
      </div>
    )}
    <h1 className="text-heading-1">{props.title}</h1>
    {props.children}
  </div>
);
